import React from "react";
import "./down.css";

function Down() {
  return (
    <div>
      <h2>Powered By Mohamed Javith</h2>
    </div>
  );
}
export default Down;
